import React from "react";
import { SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";

const usersLoaders = [1, 2, 3, 4, 5, 6, 7];
const columnsLoaders = [1, 2, 3, 4, 5, 6, 7, 8];

export const CapacityLoader = () => {
  return (
    <div className="tw-flex tw-w-full tw-min-w-0">
      <div className="tw-w-52 md:tw-w-96 tw-shrink-0">
        <div className="tw-h-10 tw-px-5 tw-flex tw-items-center tw-border-b tw-border-border-primary tw-border-solid tw-border-0">
          <SkeletonLoader
            data-testid="linear-loader"
            className="tw-w-28"
          />
        </div>

        <div className="tw-h-10 tw-px-5 tw-flex tw-items-center tw-border-b tw-border-r tw-border-border-primary tw-border-solid tw-border-0 tw-bg-primary-200">
          <SkeletonLoader
            data-testid="linear-loader"
            className="tw-w-28"
          />
        </div>

        {usersLoaders.map((user) => (
          <div
            key={user}
            className="odd:tw-bg-theme-200 tw-h-10 tw-px-5 tw-flex tw-items-center tw-border-b tw-border-r tw-border-border-primary tw-border-solid tw-border-0 tw-gap-1"
          >
            <SkeletonLoader
              data-testid="linear-loader"
              className="tw-w-6 tw-h-6 tw-rounded-full"
            />
            <SkeletonLoader
              data-testid="linear-loader"
              className="tw-w-[267px]"
            />
          </div>
        ))}
      </div>

      <div className="tw-min-w-0 tw-overflow-x-auto tw-flex-grow">
        <div className="tw-min-w-max">
          <div className="tw-flex">
            {columnsLoaders.map((col) => (
              <div
                key={col}
                className="tw-flex-[1_0_104px] tw-flex tw-flex-col [&:last-child>div:last-child]:tw-border-r-0"
              >
                <div className="tw-h-10 tw-w-full tw-flex tw-items-center tw-justify-center tw-border-b tw-border-border-primary tw-border-solid tw-border-0">
                  <SkeletonLoader
                    data-testid="linear-loader"
                    className="tw-w-8"
                  />
                </div>
                <div className="tw-h-10 tw-w-full tw-flex tw-items-center tw-justify-center tw-border-r tw-border-b tw-border-border-primary tw-border-solid tw-border-0 tw-bg-primary-200">
                  <SkeletonLoader
                    data-testid="linear-loader"
                    className="tw-w-8"
                  />
                </div>
              </div>
            ))}
          </div>

          {usersLoaders.map((user, index) => (
            <div
              key={user}
              className="tw-flex"
            >
              {columnsLoaders.map((col) => {
                return (
                  <div
                    key={col}
                    className={classNames(
                      {
                        "tw-bg-theme-200": index % 2 === 0,
                      },
                      "tw-h-10 tw-flex-[1_0_104px] tw-flex tw-items-center tw-justify-center tw-border-r tw-border-b tw-border-border-primary tw-border-solid tw-border-0 last:tw-border-r-0"
                    )}
                  >
                    <SkeletonLoader
                      data-testid="linear-loader"
                      className="tw-w-8"
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <div className="tw-w-[104px] tw-shrink-0">
        <div className="tw-h-10 tw-flex tw-items-center tw-justify-center tw-border-b tw-border-border-primary tw-border-solid tw-border-0">
          <SkeletonLoader
            data-testid="linear-loader"
            className="tw-w-8"
          />
        </div>

        <div className="tw-h-10 tw-flex tw-items-center tw-justify-center tw-border-b tw-border-l tw-border-border-primary tw-border-solid tw-border-0 tw-bg-primary-200">
          <SkeletonLoader
            data-testid="linear-loader"
            className="tw-w-8"
          />
        </div>
        {usersLoaders.map((user) => (
          <div
            key={user}
            className="tw-h-10 tw-flex tw-items-center tw-justify-center tw-border-b tw-border-l tw-border-border-primary tw-border-solid tw-border-0 tw-bg-primary-200"
          >
            <SkeletonLoader
              data-testid="linear-loader"
              className="tw-w-8"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
